import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../../caseLawDocuments/common/Constants";
import { IOrganisation } from "../model/Organisation";
import OrganisationMapper from "../service/OrganisationMapper";
import OrganisationParamMapper from "../service/OrgansationParamMapper";

export default class GetAllOrganisationsInteractor {
  private resource: GetAllResourceEntriesInteractor<IOrganisation>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      Constants.organisationsPath,
      OrganisationMapper,
      OrganisationParamMapper
    );
  }
}
